import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=a447ddc4&scoped=true&"
import script from "./CategoryList.vue?vue&type=script&lang=js&"
export * from "./CategoryList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryList.vue?vue&type=style&index=0&id=a447ddc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a447ddc4",
  null
  
)

export default component.exports